import { cn, useLG } from "@/lib/utils";
import ExportedImage from "next-image-export-optimizer";
import { useEffect, useState } from "react";
import store from "stores/store";
import { getAltTextFromGeneralImage, getImageUrlFromGeneralImage } from "utils/imageHelpers";

type FooterProps = {
    className?: string;
};

const Footer: React.FC<FooterProps> = ({ className }) => {
    if (!store) {
        throw Error("Component was not setup correctly");
    }

    const { startLocalized } = store;

    const [windowWidth, setWindowWidth] = useState(0);

    useEffect(() => {
        setWindowWidth(window.innerWidth);

        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const getScreenSize = () => {
        if (windowWidth < 1024) {
            return true;
        } else if (windowWidth < 1280) {
            return false;
        }
    };

    const footer = getScreenSize();
    return (
        <>
            <div
                className={cn(
                    "flex justify-center bg-neutral-300 px-[16px] pt-[48px] pb-[80px] w-full h-[316.5px] max-h-[316.5px]",
                    "font-frutigerRoman text-[12px] leading-[135%] text-white",
                    "md:max-h-[238.5px] md:px-[42px]",
                    "lg:max-h-[124.5px] lg:px-[99px] lg:pb-[32px]",
                    className,
                )}
            >
                <div
                    className={cn(
                        "flex flex-col items-center gap-[48px]",
                        "md:w-full md:max-w-[690px] md:items-start",
                        "lg:max-w-[960px] lg:flex-row lg:items-center lg:justify-between",
                        "xl:max-w-[1140px]",
                    )}
                >
                    <div
                        onClick={() => window.open(startLocalized?.footerLogoLink ?? "/", "_blank")}
                        className="relative w-[139px] h-[44.5px] cursor-pointer"
                    >
                        <ExportedImage
                            src={
                                startLocalized?.footerLogo !== undefined && startLocalized?.footerLogo !== null
                                    ? getImageUrlFromGeneralImage(startLocalized?.footerLogo)
                                    : "No image provided"
                            }
                            alt={
                                startLocalized?.footerLogo !== undefined && startLocalized?.footerLogo !== null
                                    ? getAltTextFromGeneralImage(startLocalized?.footerLogo)
                                    : "No image provided"
                            }
                            layout="fill"
                            objectFit="contain"
                        />
                    </div>
                    {footer && (
                        <div className={cn("flex flex-col gap-[8px]", "md:w-full md:flex-row md:justify-between")}>
                            <div>{startLocalized?.footerClaim}</div>
                            <div className={cn("flex flex-col items-center gap-2 cursor-pointer", "md:flex-row")}>
                                <div onClick={() => window.open(startLocalized?.footerImprint.link ?? "/", "_blank")}>
                                    {startLocalized?.footerImprint.title}
                                </div>
                                <div
                                    onClick={() =>
                                        window.open(startLocalized?.footerPrivacyPolicy.link ?? "/", "_blank")
                                    }
                                >
                                    {startLocalized?.footerPrivacyPolicy.title}
                                </div>
                                <div onClick={() => window.open(startLocalized?.footerContact.link ?? "/", "_blank")}>
                                    {startLocalized?.footerContact.title}
                                </div>
                                <div onClick={() => window.open(startLocalized?.footerAccessibility.link ?? "/", "_blank")}>
                                    {startLocalized?.footerAccessibility.title}
                                </div>
                                <div className="px-1 py-0.5 border" onClick={() => window.open("https://www.neueleben.de/widerruf-uebermitteln.html", "_blank")}>
                                    Vertrag wiederrufen
                                </div>
                            </div>
                        </div>
                    )}
                    {!footer && (
                        <>
                            <div>{startLocalized?.footerClaim}</div>
                            <div className={cn("flex flex-col items-center gap-2 cursor-pointer", "md:flex-row")}>
                                <div onClick={() => window.open(startLocalized?.footerImprint.link ?? "/", "_blank")}>
                                    {startLocalized?.footerImprint.title}
                                </div>
                                <div
                                    onClick={() =>
                                        window.open(startLocalized?.footerPrivacyPolicy.link ?? "/", "_blank")
                                    }
                                >
                                    {startLocalized?.footerPrivacyPolicy.title}
                                </div>
                                <div onClick={() => window.open(startLocalized?.footerContact.link ?? "/", "_blank")}>
                                    {startLocalized?.footerContact.title}
                                </div>
                                <div onClick={() => window.open(startLocalized?.footerAccessibility.link ?? "/", "_blank")}>
                                    {startLocalized?.footerAccessibility.title}
                                </div>
                                <div className="px-1 py-0.5 border" onClick={() => window.open("https://www.neueleben.de/widerruf-uebermitteln.html", "_blank")}>
                                    Vertrag widerrufen
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default Footer;
